import { useState } from "react"

function TextFilter({ title, chooseText }) {

    const [value, setValue] = useState("")

    const handleClick = (e) => {
        setValue(e.target.value)
        chooseText(e.target.value)
    }

    return (
        <div className="flex flex-row-reverse items-center mb-4">
            <p className="w-40">{title}</p>
            <input
                value={value}
                onChange={handleClick}
                className="w-80 p-1 border border-slate-200 rounded"
            />
        </div>
    )
}
export default TextFilter;